import { IKeyword } from "@/models/IKeyword";

import { BaseRepository } from "@/repositories/BaseRepository";

class KeywordRepository extends BaseRepository<IKeyword> {
    constructor() {
        super("/Keywords");
    }

    public getKeywords(): Promise<IKeyword[]> {
        const path = "keywords";

        return this.getAll({}, path);
    }
}

const keywordRepository = new KeywordRepository();

export { KeywordRepository, keywordRepository };
